import { useTheme } from "vuetify";

interface Theme {
  name: string;
  dark: Record<string, string>;
  light: Record<string, string>;
}

const parseTheme = (themeString: string): Theme | null => {
  try {
    const theme: Theme = JSON.parse(themeString);

    if (
      typeof theme.name === 'string' &&
      typeof theme.dark === 'object' &&
      typeof theme.light === 'object'
    ) {
      return theme;
    }

    console.error('Invalid theme format:', theme);
    return null;
  } catch (error) {
    console.error('Error parsing theme:', error);
    return null;
  }
};

export const applyTheme = (vuetifyTheme: ReturnType<typeof useTheme>, themeString: string) => {
  const theme = parseTheme(themeString);
  if (!theme) return;

  const { name, dark, light } = theme;

  Object.keys(dark).forEach((key) => {
    (vuetifyTheme.themes.value.dark.colors as Record<string, string>)[key] = dark[key];
  });

  Object.keys(light).forEach((key) => {
    (vuetifyTheme.themes.value.light.colors as Record<string, string>)[key] = light[key];
  });

  (vuetifyTheme as any).name = name;
};

